import React from 'react';
import moment from 'moment';
import { uniq } from 'lodash';

export const COLUMNS = [
    {
        name: 'when',
        label: 'Time',
        minWidth: 0,
        value: row => {
            return (
                <span className="time-customer">
                    <span className="time-xx">{ row.when && moment(row.when).format('DD/MM/YYYY HH:mm:ss') }</span>
                    <br />
                    { row.account && row.account.name }
                </span>
            );
        }
    },
    {
        name: 'action',
        label: 'Action',
        minWidth: 0,
    },
    {
        name: 'taken_by_name',
        label: 'Taken By',
        minWidth: 0,
        value: (row) => row.assignee.name !== void 0 && (row.assignee.name === null ? '--' : row.assignee.name)
    },
    {
        name: 'taken_by_id',
        label: 'Taken By ID',
        minWidth: 0,
        value: (row) => row.assignee.id !== void 0 && (row.assignee.id === null ? '--' : row.assignee.id)
    },
    {
        name: 'executor_id',
        label: 'Executor ID',
        minWidth: 0,
        value: (row) => row.executor.id !== void 0 && (row.executor.id === null ? '--' : row.executor.id)
    },
    {
        name: 'inPlay',
        label: 'In-play',
        minWidth: 0,
        value: row => row.legs.length ? (row.legs.reduce((value, next) => value && next.inPlay, true) ? 'Y' : 'N') : ''
    },
    {
        name: 'sport',
        label: 'Sport',
        minWidth: 777,
        value: row => uniq(
            row.legs.map(leg => leg.sport && leg.sport.name)
        ).filter(x => x).join(', ') || '-'
    },
    {
        name: 'competition',
        label: 'Competition',
        minWidth: 0,
        value: row => uniq(
            row.legs.map(leg => leg.competition && leg.competition.name)
        ).filter(x => x).join(', ') || '-'
    },
    {
        name: 'event',
        label: 'Event',
        minWidth: 777,
        value: row => {
            let title = uniq(row.legs.map(leg => leg.event.id)).join(', ');
            return <span title={ title } className="truncated">{ title }</span>;
        }
    },
    {
        name: 'market',
        label: 'Market',
        minWidth: 0,
        value: row => uniq(
            row.legs.map(leg => leg.market && leg.market.id)
        ).filter(x => x).join(', ') || '-'
    },
    {
        name: 'selection-column',
        label: 'Selection',
        minWidth: 0,
        value: row => uniq(row.legs.map(leg => leg.selection.id)).join(', ')
    },
    {
        name: 'price',
        label: 'Price',
        minWidth: 0,
        value: (row) => row.legs.length ? row.legs[0].price && row.legs[0].price.f : ''
    },
    {
        name: 'priceType',
        label: 'Price type',
        minWidth: 777,
        value: (row) => row.legs.length ? row.legs[0].priceType.toUpperCase() : ''
    },
    {
        name: 'ew',
        label: 'EW',
        minWidth: 0,
        value: (row) => row.eachWay !== void 0 && (row.eachWay ? 'Y' : 'N')
    },
    {
        name: 'type',
        label: 'Bet type',
        minWidth: 0
    },
    {
        name: 'stakePerLine',
        label: 'Stake per line',
        minWidth: 0,
        value: (row) => row.stakePerLine !== void 0 && parseFloat(row.stakePerLine / 100)
    },
    {
        name: 'totalStake',
        label: 'Total stake',
        minWidth: 777,
        value: (row) => row.totalStake !== void 0 && parseFloat(row.totalStake / 100)
    },
    {
        name: 'channel',
        label: 'Channel',
        minWidth: 0
    }
];
